import { render, staticRenderFns } from "./AddSite.vue?vue&type=template&id=56a6e84c&"
import script from "./AddSite.vue?vue&type=script&lang=js&"
export * from "./AddSite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports